import { useEffect } from "react";
import { useLocaleContext } from "src/context/locale-context";
import "./WaavoWidget.css";

// Third-party package-tour search widget (waavo.com), gated behind
// REACT_APP_ENABLE_CHARTER_IFRAME so the external script only loads once enabled.
// Shared between the standalone /charter-flights page and the "Atpūtas ceļojumi" tab
// on the home page — same widget, two mount points.
export function WaavoWidget() {
  const { currentLanguage } = useLocaleContext();
  const enableCharterIframe = window.SERVER_DATA?.REACT_APP_ENABLE_CHARTER_IFRAME === "true";

  useEffect(() => {
    if (!enableCharterIframe) return;
    const script = document.createElement("script");
    script.src = "https://www.waavo.com/js/waavo_loader.min.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
      const waavoDiv = document.getElementById("waavo-insert-iframe");
      if (waavoDiv) {
        waavoDiv.innerHTML = "";
      }
    };
  }, [currentLanguage, enableCharterIframe]);

  if (!enableCharterIframe) return null;

  return (
    <div className="charter-iframe-wrapper">
      <div
        id="waavo-insert-iframe"
        className="waavo-iframes"
        data-cookie-agreement="1"
        data-https="true"
        data-host="ltd.waavo.com"
        data-language={currentLanguage === "lv" ? "lav" : currentLanguage}
        data-url="/travels_search"
      />
    </div>
  );
}
